{
  "addFleet": "Aggiungi flotta",
  "table": {
    "empty": "Nessuna flotta trovata",
    "column": {
      "fleet": "Flotta",
      "devices": "Apparati",
      "createdAt": "Creato alle",
      "updatedAt": "Aggiornato alle",
      "incompatibleDevices": "Apparati incompatibili",
      "information": {
        "incompatibleDevices": "Alcuni apparati della flotta non sono compatibili con i parametri attuali.",
        "fleetHasChanged": "L’ambito della flotta è stato modificato",
        "noDeviceCompatible": "Nessun apparato di questa flotta è compatibile con la parametrizzazione della campagna attuale"
      }
    }
  },
  "addDevices": "Aggiungi apparati",
  "form": {
    "createFleet": {
      "header": "Crea una nuova flotta",
      "validate": "Crea flotta",
      "cancel": {
        "confirmMessage": "Vuoi davvero annullare la creazione della flotta?"
      }
    },
    "validation": {
      "name": "L’etichetta è obbligatoria",
      "uniqueName": "L’etichetta della flotta deve essere univoca"
    },
    "header": {
      "addDevices": "Aggiungi apparati selezionati a una flotta",
      "createFleet": "Crea una flotta"
    },
    "newFleet": "Nuova flotta",
    "name": "Etichetta flotta",
    "saveSuccess": "La flotta {fleetName} è stata creata correttamente."
  },
  "attachDevices": {
    "updateSuccess": "Nessun apparato aggiunto | L’aggiunta dell’apparato alla flotta {fleetName} è andata a buon fine. | L’aggiunta degli apparati alla flotta {fleetName} è andata a buon fine.",
    "title": "Collega gli apparati alla flotta",
    "confirmMessage": "Annullare l’operazione? La tua selezione andrà persa."
  },
  "removeDevices": {
    "confirmMessage": "Rimuovere questo apparato dalla flotta? | Rimuovere questo apparato dalla flotta? | Rimuovere questi apparati dalla flotta?",
    "confirmTitle": "Rimuovere dalla flotta"
  },
  "actionForbidden": "Non hai l’autorizzazione richiesta per questa azione.",
  "delete": {
    "title": "Rimuovi la flotta",
    "confirm": {
      "message": "Rimuovere la flotta selezionata?"
    }
  },
  "quickActions": {
    "selectedFleets": "Nessuna flotta selezionata | {count} flotta selezionata | {count} flotte selezionate",
    "delete": {
      "title": "Nessuna flotta da rimuovere | Rimuovi una flotta | Rimuovi flotte"
    }
  },
  "bulkDelete": {
    "confirm": {
      "title": "Nessuna flotta da rimuovere | Rimuovi flotta | Rimuovi flotte",
      "message": "Nessuna flotta da rimuovere | Rimuovere la flotta selezionata? | Rimuovere le flotte selezionate?"
    }
  }
}
